import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import { Input, Label, SelectGeneric, Switch } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';

import { ubicationTypeEnum } from '../../utils/dataStatus';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

import {
  checkIfLocationTypeGeneric,
  shouldShowTypeObjectDuct,
  shouldShowTypeObjectEnergy,
  shouldShowTypeObjectGeneric,
  shouldShowTypeObjectLocation,
  shouldShowTypeObjectOyMWithoutDuct,
  shouldShowTypeObjectPozo
} from './AddUbicationFormAdapter';

const AddUbicationForm = ({
  aditionalTeams,
  handleSwitchAdditionTeams,
  isCreateASDS,
  isCreateRequestService,
  isMSDS,
  objectEquipment,
  objectClassification,
  objectEvent,
  objectInstallation,
  objectTeam,
  objectTypeEvent,
  objectUbication,
  objectUbicationType,
  objectUunn,
  objectActive,
  onClickTypeInputation,
  warning,
  getWellsError
}) => {
  const { values } = useFormikContext();

  const isLocationTypeGeneric = checkIfLocationTypeGeneric(values);

  const showTypeObjectLocation = shouldShowTypeObjectLocation(values);

  const showTypeObjectPozo = shouldShowTypeObjectPozo(values);

  const showTypeObjectOyMWithoutDuct = shouldShowTypeObjectOyMWithoutDuct(values);

  const showTypeObjectDuct = shouldShowTypeObjectDuct(values);

  const showTypeObjectEnergy = shouldShowTypeObjectEnergy(values);

  const showTypeObjectGeneric = shouldShowTypeObjectGeneric(values);

  const isValidUbicationForm =
    showTypeObjectLocation ||
    showTypeObjectPozo ||
    showTypeObjectDuct ||
    showTypeObjectOyMWithoutDuct ||
    showTypeObjectEnergy ||
    showTypeObjectGeneric;

  const renderImputationDetails =
    (isCreateRequestService || (isCreateASDS && !values.isOyM)) && isValidUbicationForm;

  const { isTemplate } = values;

  const checkIsGenericUbicationType = () =>
    values.ubication.ubicationType?.id === ubicationTypeEnum.genericaOverhead ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.genericaProyecto;

  const checkToAddActive = () =>
    values.ubication.ubicationType?.id === ubicationTypeEnum.pozoOyM ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.plantaAyP ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.plantaGas ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.ducto ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.edificio ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.uspYBateria ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.almacen ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.energia ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.talleresYBasesDeProveedores ||
    values.ubication.ubicationType?.id === ubicationTypeEnum.locacionOYM ||
    checkIsGenericUbicationType();

  return (
    <>
      <Row>
        <Col sm={6}>
          <SelectGeneric
            isDisabled={objectUbicationType?.isDisabled}
            label={objectUbicationType?.label}
            name={objectUbicationType?.name}
            onChange={objectUbicationType?.onChange}
            optionMapper={{
              value: 'id',
              label: 'nombre'
            }}
            options={objectUbicationType?.options}
            paddingIndicator={4}
            placeholder={objectUbicationType?.placeholder}
            value={objectUbicationType?.value}
            withSelect="100%"
          />
        </Col>
        <Col sm={6}>
          <SelectGeneric
            defaultValueOneOption={false}
            errors={objectUunn?.errors}
            isDisabled={objectUunn?.isDisabled}
            label={objectUunn?.label}
            name={objectUunn?.name}
            onChange={objectUunn?.onChange}
            options={objectUunn?.options}
            paddingIndicator={4}
            placeholder={objectUunn?.placeholder}
            value={objectUunn?.value}
            withSelect="100%"
          />
        </Col>
      </Row>
      <Row>
        {checkToAddActive() && (
          <Col sm={6}>
            {/* Cuando es generica overhead o generica proyecto y activo tiene mas de una opcion probable se debe comportar como un combo desplegable */}
            {objectActive.options.length && checkIsGenericUbicationType() ? (
              <SelectGeneric
                clearable={objectActive.clearable}
                defaultValueOneOption={false}
                errors={objectActive?.errors}
                isDisabled={objectActive?.isDisabled}
                label={objectActive?.label}
                name={objectActive?.name}
                onChange={objectActive?.onChange}
                options={objectActive.options}
                paddingIndicator={4}
                placeholder={objectActive?.placeholder}
                value={objectActive?.value}
                withSelect="100%"
              />
            ) : (
              <SelectGeneric
                async
                clearable={objectActive.clearable}
                defaultValueOneOption={false}
                errors={objectActive?.errors}
                fetchData={objectActive?.fetchData}
                isDisabled={objectActive?.isDisabled}
                label={objectActive?.label}
                name={objectActive?.name}
                noOptionsMessage="Ingresar al menos 3 caracteres"
                onChange={objectActive?.onChange}
                options={objectActive.options}
                paddingIndicator={4}
                placeholder={objectActive?.placeholder}
                value={objectActive?.value}
                withSelect="100%"
              />
            )}
          </Col>
        )}
        {!isTemplate && (
          <>
            {(values.ubication.ubicationType?.id === ubicationTypeEnum.ducto ||
              values.ubication.ubicationType?.id === ubicationTypeEnum.energia) && (
              <Col sm={6}>
                <SelectGeneric
                  async
                  fetchData={objectInstallation.fetchData}
                  isDisabled={objectInstallation.isDisabled}
                  label={objectInstallation.label}
                  name={objectInstallation.name}
                  noOptionsMessage="Ingresar al menos 3 caracteres"
                  onChange={objectInstallation.onChange}
                  options={objectInstallation.options}
                  paddingIndicator={4}
                  placeholder={objectInstallation.placeholder}
                  value={objectInstallation.value}
                  withSelect="100%"
                />
              </Col>
            )}
            {isLocationTypeGeneric && (
              <Col sm={6}>
                <SelectGeneric
                  async
                  fetchData={objectClassification.fetchData}
                  isDisabled={objectClassification?.isDisabled}
                  label={objectClassification?.label}
                  name={objectClassification?.name}
                  noOptionsMessage="Ingresar al menos 3 caracteres"
                  onChange={objectClassification.onChange}
                  paddingIndicator={4}
                  placeholder={objectClassification?.placeholder}
                  value={objectClassification?.value}
                  withSelect="100%"
                />
              </Col>
            )}

            <Col sm={6}>
              <SelectGeneric
                async
                fetchData={objectUbication?.fetchData}
                isDisabled={objectUbication?.isDisabled}
                label={objectUbication?.label}
                name={objectUbication?.name}
                noOptionsMessage="Ingresar al menos 3 caracteres"
                onChange={objectUbication?.onChange}
                paddingIndicator={4}
                placeholder={objectUbication?.placeholder}
                value={objectUbication?.value}
                withSelect="100%"
              />
            </Col>
            {values.ubication.ubicationType?.id === ubicationTypeEnum.locacion && (
              <Col>
                <SelectGeneric
                  isDisabled={objectTypeEvent?.isDisabled}
                  label={objectTypeEvent?.label}
                  name={objectTypeEvent?.name}
                  onChange={objectTypeEvent?.onChange}
                  optionMapper={{
                    value: 'id',
                    label: 'nombre'
                  }}
                  options={objectTypeEvent?.options}
                  paddingIndicator={4}
                  placeholder={objectTypeEvent?.placeholder}
                  value={objectTypeEvent?.value}
                  withSelect="100%"
                />
              </Col>
            )}
            {values.ubication.ubicationType?.id === ubicationTypeEnum.pozo && (
              <Col sm={6}>
                <SelectGeneric
                  isDisabled={objectEvent.isDisabled}
                  label={objectEvent.label}
                  name={objectEvent.name}
                  onChange={objectEvent.onChange}
                  optionMapper={{
                    value: 'eventoPozoId',
                    label: 'nombre'
                  }}
                  options={objectEvent.options}
                  paddingIndicator={4}
                  placeholder={objectEvent.placeholder}
                  value={objectEvent.value}
                  withSelect="100%"
                />
              </Col>
            )}
            {isMSDS && values.isOyM && !isLocationTypeGeneric && (
              <Col sm={6}>
                <Input
                  errors={objectEquipment.errors}
                  isInvalid={values.ubication.equipment?.length > 10}
                  label={objectEquipment.label}
                  name={objectEquipment.name}
                  onChange={objectEquipment.onChange}
                  type="text"
                />
              </Col>
            )}
          </>
        )}
      </Row>

      {values.ubication.ubicationType?.id === ubicationTypeEnum.pozo && !isTemplate && (
        <Row>
          <Col sm={6}>
            <SelectGeneric
              clearable={objectTeam.clearable}
              defaultValueOneOption={false}
              isDisabled={objectTeam.isDisabled}
              label={objectTeam.label}
              name={objectTeam.name}
              onChange={objectTeam.onChange}
              options={objectTeam.options}
              paddingIndicator={4}
              placeholder={objectTeam.placeholder}
              value={objectTeam.value}
              withSelect="100%"
            />
          </Col>
          <Col sm={2}>
            <div className="switch-teams">
              <h6>Ver todos los equipos</h6>
              <Switch
                checked={aditionalTeams}
                falseLabel="NO"
                name="businessUnitSwitch"
                onChange={handleSwitchAdditionTeams}
                size="sm"
                trueLabel="SÍ"
              />
            </div>
          </Col>
        </Row>
      )}

      {renderImputationDetails && (
        <Col sm={4}>
          <div className="mt-label">
            <Label
              fullWidth
              icon={warning ? BsFillExclamationCircleFill : null}
              iconPosition="right"
              iconWarning={warning}
              label="Tipo y objeto de imputación"
              onClick={onClickTypeInputation}
              size="md"
              sizeValue="lg"
              value="VER DETALLES"
              variant="fill"
            />
            {!values.isOyM && <ErrorMessage message={getWellsError()} />}
          </div>
        </Col>
      )}
    </>
  );
};

const objectSelectProps = PropTypes.shape({
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string
    })
  ),
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string
    }),
    PropTypes.string
  ]),
  errors: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      value: PropTypes.number,
      label: PropTypes.string
    }),
    PropTypes.string
  ]),
  fetchData: PropTypes.func,
  clearable: PropTypes.bool
});

AddUbicationForm.propTypes = {
  aditionalTeams: PropTypes.bool.isRequired,
  handleSwitchAdditionTeams: PropTypes.func.isRequired,
  isCreateASDS: PropTypes.bool,
  isCreateRequestService: PropTypes.bool,
  isMSDS: PropTypes.bool,
  objectEquipment: objectSelectProps,
  objectEvent: objectSelectProps.isRequired,
  objectInstallation: objectSelectProps.isRequired,
  objectClassification: objectSelectProps.isRequired,
  objectTeam: objectSelectProps.isRequired,
  objectTypeEvent: objectSelectProps.isRequired,
  objectUbication: objectSelectProps.isRequired,
  objectUbicationType: objectSelectProps.isRequired,
  objectUunn: objectSelectProps.isRequired,
  objectActive: objectSelectProps.isRequired,
  onClickTypeInputation: PropTypes.func.isRequired,
  warning: PropTypes.func,
  getWellsError: PropTypes.func
};

AddUbicationForm.defaultProps = {
  isCreateASDS: false,
  isCreateRequestService: false,
  isMSDS: false,
  objectEquipment: null,
  warning: () => {},
  getWellsError: () => {}
};

export default React.memo(AddUbicationForm);
